import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  width: 90%;

  @media (min-width: 576px) {
    width: 90%;
  }

  @media (min-width: 992px) {
    width: 80%;
  }
`;
